import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Users, 
  UserPlus,
  Calendar
} from 'lucide-react';
import NewClientModal from '../components/NewClientModal';

// Update this path to match your logo location
import Logo from '../../assets/logo.webp';

const AdminLandingPage = () => {
  const navigate = useNavigate();
  const [isNewClientModalOpen, setIsNewClientModalOpen] = useState(false);

  // Define all tools available in the CRM - without Documents and Reports
  const crmTools = [
    {
      id: 'add-client',
      name: 'Add New Client',
      description: 'Create a new client profile',
      icon: UserPlus,
      color: 'bg-teal-500',
      action: 'newClient'
    },
    {
      id: 'clients',
      name: 'Client Management',
      description: 'Manage client profiles, track progress, and view history',
      icon: Users,
      color: 'bg-teal-500',
      path: '/admin/dashboard/clients'
    },
    {
      id: 'sessions',
      name: 'Sessions',
      description: 'Schedule and manage counseling sessions',
      icon: Calendar,
      color: 'bg-teal-500',
      path: '/admin/dashboard/sessions'
    }
  ];

  const handleToolClick = (tool) => {
    if (tool.action === 'newClient') {
      setIsNewClientModalOpen(true);
    } else {
      navigate(tool.path);
    }
  };

  return (
    <div className="min-h-screen bg-teal-600 flex flex-col">
      {/* Header */}
      <header className="py-6 px-4 sm:px-6 lg:px-8 flex justify-center">
        <div className="flex flex-col items-center">
          <img 
            src={Logo}
            alt="Nirvana Career Counselling"
            className="h-24 lg:h-28 object-contain mb-4"
          />
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center">
            Admin Dashboard
          </h1>
          <p className="mt-2 text-teal-100 text-center max-w-2xl">
            Manage your clients, sessions, documents, and more
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {crmTools.map((tool) => (
            <div 
              key={tool.id}
              onClick={() => handleToolClick(tool)}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow transform hover:-translate-y-1 cursor-pointer"
            >
              <div className={`${tool.color} h-2 w-full`}></div>
              <div className="p-6">
                <div className="flex items-center">
                  <div className={`${tool.color} p-3 rounded-lg`}>
                    <tool.icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="ml-4 text-xl font-semibold text-gray-800">
                    {tool.name}
                  </h3>
                </div>
                <p className="mt-3 text-gray-600">
                  {tool.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-teal-700 py-4 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto">
          <p className="text-center text-teal-100 text-sm">
            &copy; {new Date().getFullYear()} Nirvana Career Counselling. All rights reserved.
          </p>
        </div>
      </footer>

      {/* New Client Modal */}
      <NewClientModal 
        isOpen={isNewClientModalOpen}
        onClose={() => setIsNewClientModalOpen(false)}
        onClientAdded={(newClient) => {
          setIsNewClientModalOpen(false);
          // Immediately redirect to client management page after adding a client
          navigate('/admin/dashboard/clients');
        }}
      />
    </div>
  );
};

export default AdminLandingPage;